import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Primary/secondary CTA button rendered as a router Link.
 */
export const CTALink = ({ to, children, variant = "primary", size = "lg", withArrow = false, className = "", ...props }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition-colors transition-shadow transition-transform duration-200 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[var(--et-ring)] active:scale-[0.98]";
  const sizes = { md: "h-11 px-5 text-sm", lg: "h-12 px-6 text-sm sm:text-base" };
  const variants = {
    primary:
      "bg-[var(--et-primary)] text-white shadow-[0_10px_24px_rgba(37,99,235,0.22)] hover:bg-[var(--et-primary-hover)] hover:-translate-y-0.5",
    secondary:
      "bg-white text-slate-900 border border-slate-200 hover:bg-slate-50 hover:border-slate-300",
    ghost: "bg-transparent text-slate-900 hover:bg-slate-100",
    accent:
      "bg-[var(--et-accent)] text-slate-900 shadow-[0_10px_24px_rgba(244,180,0,0.28)] hover:brightness-95 hover:-translate-y-0.5",
    navy: "bg-white text-[var(--et-navy)] hover:bg-slate-100",
    outlineLight:
      "bg-transparent text-white border border-white/30 hover:bg-white/10",
  };
  return (
    <Link to={to} className={cn(base, sizes[size], variants[variant], className)} {...props}>
      {children}
      {withArrow && <ArrowRight className="h-4 w-4" />}
    </Link>
  );
};
